var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPosition(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 29,
    viewBox: "0 0 23 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.4763 0C16.4686 0.0517964 20.8613 3.31127 22.4125 8.1715C23.1792 10.5371 23.1959 13.0926 22.4603 15.4687C21.7246 17.8447 20.2748 19.9182 18.3203 21.3895C16.2723 22.9286 14.599 24.7858 13.3518 27.0624C13.1124 27.5088 12.8611 27.9565 12.5774 28.3771C12.0173 29.2107 10.9855 29.2046 10.423 28.3771C10.174 28.0071 9.96334 27.6087 9.73832 27.2215C8.42171 24.9326 6.68976 23.0285 4.65858 21.3895C0.842792 18.3002 -0.727571 14.2218 0.314948 9.34803C1.35747 4.47423 4.44314 1.46756 9.17218 0.314477C9.92025 0.120857 10.7066 0.0961934 11.4763 0ZM11.4882 17.1348C12.8389 17.1423 14.1374 16.5976 15.0988 15.6202C16.0603 14.6427 16.6063 13.3122 16.617 11.9206C16.6184 10.5293 16.0874 9.19363 15.1391 8.20319C14.1908 7.21276 12.9018 6.64747 11.5517 6.62994C10.8779 6.62588 10.2101 6.7587 9.5862 7.02078C8.96233 7.28287 8.39473 7.66909 7.91584 8.15736C7.43695 8.64563 7.05616 9.22637 6.79526 9.86638C6.53436 10.5064 6.39845 11.1931 6.39532 11.8873C6.39785 13.2782 6.93523 14.6114 7.88979 15.5949C8.84435 16.5785 10.1383 17.1321 11.4882 17.1348Z",
    fill: "url(#paint0_linear_29_2785)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4805 17.7519C9.96176 17.7501 8.50572 17.1268 7.43146 16.0187C6.3572 14.9105 5.75236 13.4079 5.74951 11.8403C5.75304 11.0582 5.90586 10.2846 6.19924 9.56356C6.49262 8.84254 6.92081 8.18829 7.45931 7.63821C7.99782 7.08814 8.63609 6.65303 9.33762 6.35777C10.0391 6.06251 10.7902 5.91289 11.5478 5.91746C13.0667 5.93612 14.5172 6.57248 15.5844 7.6884C16.6516 8.80431 17.2493 10.3097 17.2477 11.8778C17.2357 13.4456 16.6217 14.9444 15.5405 16.0456C14.4594 17.1468 12.9993 17.7604 11.4805 17.7519Z",
    fill: "url(#paint1_linear_29_2785)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_29_2785",
    x1: 6.13277,
    y1: 0.394488,
    x2: 12.6107,
    y2: 28.323,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0282843,
    stopColor: "#17F1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#083098"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_29_2785",
    x1: 8.04916,
    y1: 6.31185,
    x2: 14.4569,
    y2: 17.5957,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4BD4FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#84C3FE"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPosition);
export default __webpack_public_path__ + "static/media/position.0ec296dcb587f8e045411ac1529f6a6c.svg";
export { ForwardRef as ReactComponent };